// The Accelerator home's rows (Bands.jsx draws them): sections that sit side by side share a row,
// the main one on the left and the side ones stacked on the right, and a main section after a side
// one starts a new row. Pure, so a test can import it.
import { shownKeys } from '../../product/layout.js'

// The home's order below 1100px and on a phone (Adam's answer to the critique's question 4, 20 Oct): the goal with
// the big View your accountability log button straight under it, then the next session, the refocus card and this
// month's actions, then the rest in the published layout's order, a session day too. front: those keys in that order.
// They're drawn together where the first of them sits in the layout, so
// a section Adam put above them (his announcement) stays above; a section he hid stays hidden; a part that isn't a
// layout section (the refocus card) is drawn when it has something to show.
export function stackedKeys(sections, parts, front = []) {
  const keys = shownKeys(sections, parts)
  const inLayout = new Set((sections || []).map(s => s.key))
  const pinned = front.filter(k => (inLayout.has(k) ? keys.includes(k) : Boolean(parts[k]) && parts[k].when !== false))
  const isPinned = k => pinned.includes(k)
  const at = keys.findIndex(isPinned)
  if (at < 0) return [...keys, ...pinned]
  return [...keys.slice(0, at).filter(k => !isPinned(k)), ...pinned, ...keys.slice(at).filter(k => !isPinned(k))]
}

// [{ full: key } | { main: [keys], side: [keys], columns, stretch }]
export function rowBands(sections, parts) {
  const out = []
  let band = null
  for (const key of shownKeys(sections, parts)) {
    const part = parts[key]
    const place = part.place || 'full'
    if (place === 'full') {
      band = null
      out.push({ full: key })
      continue
    }
    if (!band || (place === 'main' && band.side.length)) {
      band = { main: [], side: [], columns: null, stretch: false }
      out.push(band)
    }
    band[place === 'side' ? 'side' : 'main'].push(key)
    if (!band.columns && part.columns) band.columns = part.columns
    if (part.stretch) band.stretch = true
  }
  return out
}
